import Vue from 'vue'
import Visibility from 'vue-observe-visibility'

Vue.use(Visibility)
